import 'bootstrap/dist/css/bootstrap.min.css';
import './src/styles/styles.css';
import * as React from 'react';
import { WrapRootElementBrowserArgs } from 'gatsby';

export const wrapRootElement = ({ element }: WrapRootElementBrowserArgs): JSX.Element => (
  <>
    {element}
  </>
);

export const onClientEntry = () => {
  const loadGA4IfConsent = () => {
    const consent = window.OnetrustActiveGroups || '';

    if (consent.includes(',2,')) {
      if (!document.getElementById('ga4-script')) {
        const script = document.createElement('script');
        script.id = 'ga4-script';
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=G-C8Y8763NLH';
        document.head.appendChild(script);

        window.dataLayer = window.dataLayer || [];
        function gtag(...args: any[]) { window.dataLayer.push(args); }
        gtag('js', new Date());
        gtag('config', 'G-C8Y8763NLH', { anonymize_ip: true, cookie_expires: 0 });
      }
    }
  };

  // Unify both responsibilities into a single OptanonWrapper
  window.OptanonWrapper = () => {
    // Lógica UI del banner
    const cookieSettingsBtn = document.getElementById("onetrust-pc-btn-handler");
    const btnContainer = document.getElementsByClassName("banner-actions-container")[0];
    if (cookieSettingsBtn && btnContainer) {
      btnContainer.append(cookieSettingsBtn);
    }
    // Consent logic GA4
    loadGA4IfConsent();
  };

  window.addEventListener('OneTrustGroupsUpdated', loadGA4IfConsent);
};